module.exports = __webpack_public_path__ + "static/media/knighton2019potential.f6acb318.pdf";